import { Box, BoxProps, ColorOptions, Icon, IconOptions, Spacer, Text } from '@jfs/ui-new'
import { NavigationProp, useNavigation } from '@react-navigation/native'
import { FC, useEffect } from 'react'
import { ModBox } from '../../comps/ModifiedBox/ModifiedBox'
import { useStores } from '../../data/store'
import { Routes } from '../../nav/routes'
import { getFromStore } from '../../util/util'

interface SuccessProps {
  route: any
}

const colorState = {
  success: 'AVAILABLE_GREEN',
  failure: 'ERROR',
  failed: 'ERROR',
  FAILED: 'ERROR',
  ACCEPTED: 'AVAILABLE_GREEN',
  PROCESSED: 'AVAILABLE_GREEN',
  SUCCESS: 'AVAILABLE_GREEN',
  PENDING: 'ORANGE',
  inprocess: 'INPROCESS',
}

const getIconColor = (status: keyof typeof colorState) => {
  return colorState[status]
}

const renderCloseButton = (navigation: NavigationProp) => {
  getFromStore('sessionData').then((value) => {
    const storeValue = JSON.stringify(value)
    if (storeValue !== null && storeValue !== undefined) {
      return (
        <Box {...styles.closeButton} underlayColor="TRANSPARENT" onPress={() => onClosePress(navigation)}>
          <Icon id="CLOSE" size={30} color="LIGHT_BLACK" />
        </Box>
      )
    }
  })
}

const onClosePress = (navigation: NavigationProp) => {
  navigation.reset({
    index: 0,
    routes: [
      {
        name: Routes.DASHBOARD,
      },
    ],
  })
}

const getIcon = (passedString: string) => {
  const status = passedString?.toLocaleLowerCase()
  if (status === 'success' || status === 'accepted' || status === 'processed') {
    return 'SUCCESSFUL_FILLED'
  }
  if (status === 'failed') {
    return 'CLOSE'
  }
  if (status === 'pending' || status === 'inprocess') {
    return 'SUCCESSFUL_FILLED'
  }
  return 'INFO'
}

const Success: FC<SuccessProps> = ({ route }: SuccessProps) => {
  const navigation = useNavigation()
  const { setRefundedId } = useStores((store) => ({
    setRefundedId: store.settings.metaData.setRefundedId,
  }))
  const { message, navigateTo, amount = '', status = 'SUCCESS', txnId = '' } = route?.params ?? {}
  useEffect(() => {
    setTimeout(() => {
      setRefundedId(txnId)
      navigation.reset({
        index: 0,
        routes: [
          {
            name: Routes.DASHBOARD,
            params: {
              refundedTxnId: txnId,
              refundAmount: amount,
              refundStatus: status,
              path: navigateTo,
              isReset: true,
            },
          },
        ],
      })
    }, 1000)
  }, [amount, navigateTo, navigation, setRefundedId, status, txnId])

  return (
    <Box {...styles.container}>
      {renderCloseButton(navigation)}
      <Icon size={64} id={getIcon(status) as IconOptions} color={getIconColor(status) as ColorOptions} />
      <Spacer size="MEDIUM" direction="vertical" />
      <ModBox show={amount && amount !== ''}>
        <Text fontWeight="700" fontSize="BIGGER">
          {`₹ ${amount}`}
        </Text>
      </ModBox>
      <Spacer size="MEDIUM" direction="vertical" />
      <Text fontWeight="700">{message || 'Success'}</Text>
    </Box>
  )
}

const styles = {
  container: {
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    flex: 1,
    zIndex: 100,
  } as BoxProps,
  closeButton: {
    position: 'absolute',
    top: 14,
    left: 4,
    p: 10,
    borderRadius: 20,
    borderColor: 'LIGHT_BLACK',
  } as BoxProps,
}

export default Success
